import React from 'react';
import PropTypes from 'prop-types';

const ImagePair = (props) => {
    let src = {left: '', right: ''};
    if (props.options.type === 'parallel') {
        src.left = props.sources.left;
        src.right = props.sources.right;
    } else if (props.options.type === 'crosseye') {
        src.left = props.sources.right;
        src.right = props.sources.left;
    }

    const width = (100.0 - props.options.gap) / 2.0;
    const styles = {
        left: {
            width: `${width}%`,
            marginRight: `${props.options.gap}%`
        },
        right: {width: `${width}%`}
    };

    return (
        <div className={'pair3d'}>
            <img src={src.left} alt={''} style={styles.left}/><img src={src.right} alt={''} style={styles.right}/>
        </div>
    );
};

ImagePair.propTypes = {
    sources: PropTypes.object,
    options: PropTypes.object
};

export default ImagePair;
